import axios from "axios";
import { environment } from "../../environment";

const BASE_URL = environment.contentUrl;
const HEADERS = { 'Content-Type': 'application/json' };

class SessionsService {
    async registerToClass(sessionId: string, userid: string) {
        const path = `${BASE_URL}session/register`;
        const data = { sessionId, userid };

        try {
            const res: any = await axios.patch(path, data, { headers: HEADERS });
            return res;
        } catch (err) {
            console.error("Error registering to class", err);
            throw err;
        }
    }

    async unRegisterToClass(sessionId: string, userid: string) {
        const path = `${BASE_URL}session/unregister`;
        const data = { sessionId, userid };

        try {
            const res: any = await axios.patch(path, data, { headers: HEADERS });
            return res;
        } catch (err) {
            console.error("Error unregistering to class", err);
            throw err;
        }
    }


    async getSession(id: string) {
        try {
            const path = `${environment.contentUrl}session/item/${id}`;
            const res = await axios.get(path);
            return res?.data;
        } catch (err) {
            throw err;
        }
    }

    async getSessions(ids: string[]) {
        try {
            const path = `${environment.contentUrl}session/items/${ids}`;
            const res = await axios.get(path);
            return res?.data;
        } catch (err) {
            throw err;
        }
    }

    async getSessionsForLoggedInUser(id: string) {
        try {
            const path = `${environment.contentUrl}session/logged_in_user/${id}`;
            const res = await axios.get(path);
            return res?.data;
        } catch (err) {
            throw err;
        }
    }

}


export default new SessionsService() as SessionsService;